function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7266 6.5C12.7266 5.5335 11.9431 4.75 10.9766 4.75C10.0101 4.75 9.22656 5.5335 9.22656 6.5C9.22656 7.4665 10.0101 8.25 10.9766 8.25C11.9431 8.25 12.7266 7.4665 12.7266 6.5ZM14.2266 6.5C14.2266 8.29493 12.7715 9.75 10.9766 9.75C9.18164 9.75 7.72656 8.29493 7.72656 6.5C7.72656 4.70507 9.18164 3.25 10.9766 3.25C12.7715 3.25 14.2266 4.70507 14.2266 6.5Z",
  fill: "#373737"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.167 16.251C14.1669 13.8655 12.6367 12.4181 10.751 12.418C8.86515 12.418 7.33412 13.8653 7.33398 16.251C7.33398 16.6652 6.9982 17.001 6.58398 17.001C6.16977 17.001 5.83398 16.6652 5.83398 16.251C5.83413 13.137 7.94002 10.918 10.751 10.918C13.5618 10.9181 15.6668 13.1371 15.667 16.251C15.667 16.6652 15.3312 17.001 14.917 17.001C14.5029 17.0008 14.167 16.6651 14.167 16.251Z",
  fill: "#373737"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.22754 9.41504C5.22754 8.91051 4.81834 8.50018 4.31152 8.5C3.80455 8.5 3.39453 8.91041 3.39453 9.41504C3.39455 9.91965 3.80457 10.3301 4.31152 10.3301C4.81833 10.3299 5.22752 9.91955 5.22754 9.41504ZM6.72754 9.41504C6.72752 10.7494 5.64534 11.8299 4.31152 11.8301C2.97756 11.8301 1.89455 10.7495 1.89453 9.41504C1.89453 8.08056 2.97754 7 4.31152 7C5.64535 7.00018 6.72754 8.08067 6.72754 9.41504Z",
  fill: "#373737"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.908203 16.667C0.908203 14.4336 2.36494 12.7501 4.30957 12.75C4.72378 12.75 5.05957 13.0858 5.05957 13.5C5.05957 13.9142 4.72378 14.25 4.30957 14.25C3.37554 14.2501 2.4082 15.0672 2.4082 16.667C2.40803 17.0811 2.07231 17.417 1.6582 17.417C1.2441 17.417 0.908379 17.0811 0.908203 16.667Z",
  fill: "#373737"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1064 9.41504C18.1064 8.91051 17.6972 8.50018 17.1904 8.5C16.6835 8.5 16.2734 8.91041 16.2734 9.41504C16.2735 9.91965 16.6835 10.3301 17.1904 10.3301C17.6972 10.3299 18.1064 9.91955 18.1064 9.41504ZM19.6064 9.41504C19.6064 10.7494 18.5242 11.8299 17.1904 11.8301C15.8565 11.8301 14.7735 10.7495 14.7734 9.41504C14.7734 8.08056 15.8564 7 17.1904 7C18.5243 7.00018 19.6064 8.08067 19.6064 9.41504Z",
  fill: "#373737"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0908 16.667C19.0908 15.0672 18.1235 14.25 17.1895 14.25C16.7752 14.25 16.4395 13.9142 16.4395 13.5C16.4395 13.0858 16.7752 12.75 17.1895 12.75C19.1342 12.75 20.5908 14.4335 20.5908 16.667C20.5906 17.0811 20.2549 17.417 19.8408 17.417C19.4268 17.4169 19.091 17.081 19.0908 16.667Z",
  fill: "#373737"
});

function SvgChildren(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildren);
export default __webpack_public_path__ + "static/media/children.9a0be8d7.svg";
export { ForwardRef as ReactComponent };